import getStyles from '../getStyles';

import styles from './display.module.css';

const DISPLAY = {
  fields: [
    // each sub-array represents a line
    ['address1'],
    ['address2', 'city', 'state'],
    ['zip'],
    ['country'],
  ],
  styles: getStyles(styles),
};

export default DISPLAY;
